<template>
    <v-card class="myprofile-popup">
        <v-card-title primary-title>
            {{this.memberProfileConstants.ACCOMPLISHMENT.EDIT}} {{headerLabel}}
            <i class="fas fa-times" data-qe-id ="editAccomplishments_cancelBtn" @click="cancel(false)"></i>
        </v-card-title>
        <v-card-text ref="accomplishmentDialogid" class="inner-scrollbar">
            <v-form
                v-for="(accomplishment, index) in arrAccomplishments"
                :key="index"
                :id="index"
                lazy-validation
                :ref="`accomplishment-${accomplishment.id}`"
                v-model="valid">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.NAME}} {{memberProfileConstants.ASTERISK}}</span>
                            <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                            <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen = false">
                                <v-text-field
                                    required
                                    :data-qe-id ="'editExternalHonorsAwards_name_' +index"
                                    :rules="memberProfileConstants.ACCOMPLISHMENT.ACCOMPLISHMENT_NAME_RULE"
                                    :placeholder="memberProfileConstants.TYPE_TO_SEARCH"
                                    @input="getSearchResults(accomplishment)"
                                    v-model="accomplishment.name"
                                    @keydown.down="onArrowDown"
                                    @keydown.up="onArrowUp"
                                    @keydown.enter="onEnter(accomplishment)"
                                    color="ypo_blue"
                                    :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"></v-text-field>
                                <v-list
                                    v-if="isSearchVisible(accomplishment.name) && accomplishment.isSearch"
                                    id="autocomplete-results"
                                    v-show="isSearchOpen"
                                    class="autocomplete-results inner-scrollbar">
                                    <v-list-tile
                                        class="autocomplete-result"
                                        v-for="(result, i) in results"
                                        :key="i"
                                        :data-qe-id="`accomplishment-result-${i}`"
                                        @click="setResult(accomplishment, result)"
                                        :class="{ 'is-active': i === arrowCounter }">
                                        <v-list-tile-title v-highlight="{keyword: accomplishment.name, sensitive: false}">
                                            {{ result }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.WEBSITE}} </span>
                            <v-text-field
                                height="40"
                                :data-qe-id ="'editExternalHonorsAwards_website_' +index"
                                :placeholder="memberProfileConstants.WEBSITE"
                                v-model="accomplishment.url"
                                :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                color="ypo_blue"
                                @input="edit(accomplishment)">
                            </v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 v-if="accomplishment.type === memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS">
                            <v-flex class="form-control">
                                <span class="select-label">{{displayDateLabel(accomplishment.type)}} </span>
                                <v-menu
                                    :ref="accomplishment.datePickerMenu"
                                    data-qe-id ="editAccomplishments_closeBtn1" class="calander-icon"
                                    :close-on-content-click="false" attach=""
                                    :nudge-right="40"
                                    lazy
                                    v-model="accomplishment.datePickerMenu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    max-width="290px">
                                    <v-text-field
                                        height="40"
                                        slot="activator"
                                        :data-qe-id ="'editExternalHonorsAwards_startDate_' +index"
                                        v-model="accomplishment.startDate"
                                        prepend-inner-icon="event"
                                        required
                                        readonly>
                                    </v-text-field>
                                    <v-date-picker
                                        v-model="accomplishment.startDate"
                                        :max="new Date().toISOString().substr(0, 10)"
                                        min="1900-01-01"
                                        @input="accomplishment.datePickerMenu = false"
                                        @change="edit(accomplishment)">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-flex xs12 sm6 v-if="accomplishment.type !== memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS">
                        <span class="select-label-dateFeild">{{displayDateLabel(accomplishment.type)}} </span>
                            <v-layout row wrap>
                            <v-flex xs6>
                                <v-flex class="form-control">
                                    <v-autocomplete
                                        attach                                                                        
                                        height="40"
                                        color="ypo_blue"
                                        data-qe-id="select_month_dropdown"
                                        :items="getFullMonthNames()"
                                        v-model="accomplishment.startMonth"
                                        :placeholder="memberProfileConstants.MONTH"
                                        v-on:change="edit(accomplishment)">
                                    </v-autocomplete>
                                </v-flex>
                            </v-flex>
                            <v-flex xs6>
                                <v-flex class="for2m-control">
                                    <v-autocomplete
                                        attach
                                        height="40"
                                        color="ypo_blue"
                                        :data-qe-id ="'editExternalHonorsAwards_year_' +index"
                                        v-model="accomplishment.startYear"
                                        :items="getListOfYears()"
                                        :placeholder="memberProfileConstants.YEAR"
                                        v-on:change="edit(accomplishment)"></v-autocomplete>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout v-if="accomplishment.type === memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS" row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.LOCATION}}</span>
                            <v-text-field
                                height="40"
                                :placeholder="memberProfileConstants.LOCATION"
                                data-qe-id="accomplishment_location_input"
                                v-model="accomplishment.location"
                                color="ypo_blue"
                                @input="edit(accomplishment)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.INDUSTRY}} </span>
                            <v-autocomplete
                                attach                               
                                height="40"
                                color="ypo_blue"
                                :data-qe-id ="'editExternalHonorsAwards_industry_' +index"
                                v-model="accomplishment.industryCategory"
                                :items="Object.keys(industory).sort()"
                                v-on:change="edit(accomplishment)"
                                :placeholder="memberProfileConstants.INDUSTRY"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}} </span>
                            <v-autocomplete
                                attach
                                height="40"
                                color="ypo_blue"
                                :data-qe-id ="'editExternalHonorsAwards_subIndustry_' +index"
                                v-model="accomplishment.subIndustryCategory"
                                :items="accomplishment.subIndustry"
                                :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                :no-data-text="noSubIndustry(accomplishment.subIndustry, accomplishment.industryCategory)"
                                v-on:change="edit(accomplishment)"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.TOPIC}}</span>
                            <v-text-field
                                height="40"
                                :data-qe-id ="'editExternalHonorsAwards_topic_' +index"
                                :placeholder="memberProfileConstants.TOPIC"
                                v-model="accomplishment.topic"
                                color="ypo_blue"
                                @input="edit(accomplishment)"
                                :maxlength="memberProfileConstants.MAX_NAME_LENGTH"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.DESCRIPTION}} </span>
                            <v-text-field
                                class="text-number"
                                height="40"
                                data-qe-id ="'editExternalHonorsAwards_description_' +index"
                                :placeholder="memberProfileConstants.DESCRIPTION"
                                v-model="accomplishment.description"
                                color="ypo_blue"
                                :maxlength="memberProfileConstants.MAX_LENGTH"
                                :counter="255"
                                @input="edit(accomplishment)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <status-bar :action="saveAccomplishmentAction"></status-bar>
                    <v-flex class="btn-row mt-3">
                        <v-btn
                            class="primary_btn"
                            v-if="!accomplishment.isEditDialog"
                            :disabled="!accomplishment.isAdd || !valid"
                            :data-qe-id ="'editExternalHonorsAwards_addMore_' +index"
                            @click="addAccomplishment(accomplishment)">
                            <i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}
                        </v-btn>
                        <v-btn
                            small
                            class="primary_btn"
                            :data-qe-id ="'editExternalHonorsAwards_delete_' +index"
                            @click="deleteAccomplishment(accomplishment.id, index)"
                            :disabled="accomplishment.isDelete">
                            <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                        </v-btn>
                        <v-flex class="save-to-profile" v-model="accomplishment.isSuccess" v-if="accomplishment.isSuccess">
                            <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-dialog
                    v-model="deleteInformationDialog"
                    lazy
                    absolute
                    content-class="post-actions">
                    <v-card>
                        <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                            <v-btn icon @click="deleteInformationDialog=false" data-qe-id ="editExternalHonorsAwards_closeBtn2">
                                <v-icon size="20">close</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex tag="p">
                            {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                        </v-flex>
                        <v-flex text-xs-right>
                            <status-bar :action="deleteAccomplishmentAction"></status-bar>
                            <v-btn flat @click="deleteInformationDialog = false" data-qe-id ="editExternalHonorsAwards_cancelBtn1" class="primary_btn transparent">
                                {{memberProfileConstants.CANCEL}}
                            </v-btn>
                            <v-btn dark @click="deleteInformation()" class="primary_btn" :data-qe-id ="'editExternalHonorsAwards_delete1_' +index">
                                {{memberProfileConstants.CONTINUE}}
                            </v-btn>
                        </v-flex>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-card-text>
        <status-bar :action="saveAccomplishmentAction"></status-bar>
        <status-bar :action="editAccomplishmentAction"></status-bar>
        <v-card-actions>
            <v-flex text-xs-right pa-3>
                <v-btn flat class="primary_btn transparent" data-qe-id ="editExternalHonorsAwards_cancelBtn2" @click="cancel(false)">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="primary_btn" :disabled="!valid || arrAccomplishments[0].isSave" data-qe-id ="editExternalHonorsAwards_doneBtn" @click="saveAccomplishment()">
                    {{appCommonConstants.DONE}}
                </v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { memberProfileConstants, noSubIndustry, filterResults } from "../memberProfile.constants.js";
    import { mapState, mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { getFullMonthNames, getListOfYears } from "../../../common/utils/dateTime.js";
    import { uuid } from 'vue-uuid';
    import Vue from 'vue';
    import StatusBar from "../../StatusBar/StatusBar";
    import { appCommonConstants } from "../../appCommon.constants.js";

    export default {
        name: "AccomplishmentsDialog",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            noSubIndustry,
            filterResults,
            uuid: uuid.v1(),
            isSearchOpen: false,
            results: [],
            isSearchLoading: false,
            arrowCounter: 0,
            subIndustry: [],
            getFullMonthNames,
            getListOfYears,
            deleteInformationDialog: false,
            accomplishmentId: null,
            accomplishmentDeleteIndex: null,
            valid: false,
            postBody: {
                type: null,
                name: null,
            },
        }),
        components: {
            StatusBar,
        },
        props: {
            arrAccomplishments: {
                type: Array,
                required: false,
            },
            isEditAccomplishment: {
                type: Boolean,
                required: false,
            },
            modelAccomplishment: {
                type: Object,
                required: false,
            },
            headerLabel: {
                type: String,
                required: false,
            },
            memberId: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                searchExternalConnection: `memberProfile/${storeAction.searchExternalConnection}`,
                updateAcomplishment: `memberProfile/${storeAction.updateAcomplishment}`,
                saveAccomplishments: `memberProfile/${storeAction.saveAccomplishments}`,
                deleteAccomplishments: `memberProfile/${storeAction.deleteAccomplishment}`,
            }),
            edit(accomplishment) {
                accomplishment.isEdit = true;
                accomplishment.isSave = !accomplishment.name;
                accomplishment.subIndustry = this.industory[accomplishment.industryCategory] || [];
            },
            addAccomplishment(accomplishment) {
                accomplishment.isSave = false;
                const [ref] = this.$refs[`accomplishment-null`];
                if (ref.validate()) {
                    accomplishment.isEditDialog = false;
                    accomplishment.id = this.generateGUID();
                    accomplishment.personId = this.memberId;
                    accomplishment.isEdit = false;
                    if (accomplishment.type !== this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS) {
                        accomplishment.startDate = this.getMonthYear(accomplishment.startMonth, accomplishment.startYear);
                    }
                    const postBody = [{
                        ...accomplishment,
                    }];
                    this.saveAccomplishments(postBody)
                        .then(() => {
                            ref.resetValidation();
                            accomplishment.isDelete = false;
                            accomplishment.isAdd = true;
                            accomplishment.isSuccess = true;
                            accomplishment.isEditDialog = true;
                            accomplishment.isSearch = false;
                            const index = this.arrAccomplishments.length;
                            setTimeout(() => {
                                document.getElementById(index).scrollIntoView();
                            }, 100);
                            this.arrAccomplishments.push(Vue.util.extend({}, this.modelAccomplishment));
                            this.scrollTop();
                        });
                }
            },
            deleteAccomplishment(accomplishmentId, index) {
                this.deleteInformationDialog = true;
                this.accomplishmentId = accomplishmentId;
                this.accomplishmentDeleteIndex = index;
                this.scrollTop();
            },
            deleteInformation() {
                const parms = {
                    companyId: this.accomplishmentId,
                    personId: this.memberId,
                };
                this.deleteAccomplishments(parms)
                    .then(() => {
                        this.deleteInformationDialog = false;
                        if (this.accomplishmentDeleteIndex <= 0 && this.arrAccomplishments.length === 1) {
                            this.$emit('click', false);
                        } else {
                            Vue.delete(this.arrAccomplishments, this.accomplishmentDeleteIndex);
                        }
                        this.scrollTop();
                    });
            },
            saveAccomplishment() {
                if (this.isEditAccomplishment) {                    
                    const [ref] = this.$refs[`accomplishment-${this.arrAccomplishments[0].id}`];
                    if (this.arrAccomplishments.length > 0) {
                        if (this.arrAccomplishments[0].type !== this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS) {
                            this.arrAccomplishments[0].startDate = this.getMonthYear(this.arrAccomplishments[0].startMonth, this.arrAccomplishments[0].startYear);
                        }
                    }
                    if (ref.validate()) {
                        const postbody = {
                            ...this.arrAccomplishments[0],
                        };
                        postbody.personId = this.memberId;
                        this.updateAcomplishment(postbody)
                            .then(() => {
                                ref.resetValidation();
                                this.$emit('click', false);
                                this.scrollTop();
                            });
                    }
                } else {                   
                    const [ref] = this.$refs[`accomplishment-null`];
                    if (ref.validate()) {
                        const postbody = this.arrAccomplishments.filter(x => x.isEdit === true);
                        postbody.forEach((x) => {                            
                            if (x.id === null) {
                                x.id = this.generateGUID();
                            }
                            if (x.type !== this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS) {
                                x.startDate = this.getMonthYear(x.startMonth, x.startYear);
                            }
                            x.personId = this.memberId;
                        });
                        this.saveAccomplishments(postbody)
                            .then(() => {
                                ref.resetValidation();
                                this.$emit('click', false);
                                this.scrollTop();
                            });
                    }
                }
            },
            generateGUID() {
                return uuid.v1();
            },
            getSearchResults(accomplishment) {
                this.edit(accomplishment);
                accomplishment.isAdd = true;
                accomplishment.isSearch = true;
                if (accomplishment.name !== undefined) {
                    if (accomplishment.name.length >= this.memberProfileConstants.THREE) {
                        this.postBody.type = accomplishment.type;
                        this.postBody.name = accomplishment.name;
                        this.searchExternalConnection(this.postBody)
                            .then((response) => {
                                this.results = this.filterResults(response.data, accomplishment.name);
                                this.isSearchOpen = true;
                            });
                    }
                }
            },
            setResult(accomplishment, result) {
                accomplishment.name = result;
                this.isSearchOpen = false;
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter(accomplishment) {
                accomplishment.name = this.results[this.arrowCounter];
                this.isSearchOpen = false;
                this.arrowCounter = -1;
            },
            getMonthYear(startMonth, startYear) {
                return startMonth && startYear ?
                    `${startMonth} ${startYear}` :
                    null;
            },
            isSearchVisible(accomplishmentName) {
                if (accomplishmentName !== undefined && accomplishmentName !== null) {
                    return accomplishmentName.length >= this.memberProfileConstants.THREE && this.results.length > 0;
                }
                return false;
            },
            cancel(value) {
                if (this.arrAccomplishments.length > 0) {
                    this.arrAccomplishments[0].isSave = true;
                }
                this.resetValidation();
                this.$emit('click', value);
                this.scrollTop();
            },
            scrollTop() {
                if (this.$refs.accomplishmentDialogid) {
                    this.$refs.accomplishmentDialogid.scrollTop = 0;
                }
            },
            resetValidation() {
                this.arrAccomplishments.forEach((x) => {
                    const [ref] = this.$refs[`accomplishment-${x.id}`];
                    ref.resetValidation();
                });
            },
            displayDateLabel(categoryType) {
                let response = '';
                if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS || categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS) {
                    response = this.memberProfileConstants.DATE_RECEIVED;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS || categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS) {
                    response = this.memberProfileConstants.DATE_PUBLISHED;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS) {
                    response = this.memberProfileConstants.DATE_OF_SPEECH;
                }
                return response;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            }),
            deleteAccomplishmentAction() {
                return this.actions[storeAction.deleteAccomplishment];
            },
            saveAccomplishmentAction() {
                return this.actions[storeAction.saveAccomplishments];
            },
            editAccomplishmentAction() {
                return this.actions[storeAction.updateAcomplishment];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .save-to-profile {
        display: initial;
        color: $ypo_blue;
        margin-left: 15px;
        i {
            margin-right: 8px;
        }
    }

    .v-card {
        .select-required {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-left: 560px;
            @media (max-width: 767px) {
                display: none;
            }
        }
    }
</style>
